<template>
<div>

    <div class="container" v-show="quiz">
      <div class="heading-content-title">
        {{ $t('lesson.exam.title') }}
        <div class="heading-content-right" v-for="(question,index) in questions.slice(a,b)" :key="index" v-show="quiz">
          <div class="progress">{{b}}/{{questions.length}}</div>
          <!-- Lives -->
          <div class="lives">
            <div class="icon-life" :class="(lives_cnt >= 1) ? 'star-available' : 'star-spent'"></div>
            <div class="icon-life" :class="(lives_cnt >= 2) ? 'star-available' : 'star-spent'"></div>
            <div class="icon-life" :class="(lives_cnt >= 3) ? 'star-available' : 'star-spent'"></div>
          </div>
        </div>
      </div>

      <div class="quiz-box font-jp" v-for="(question,index) in questions.slice(a,b)" :key="index">

          <div class="box-question-explanation" @click="changeTrans(selectedLanguage.key)">
            <p v-show="!trans_instruction" v-html="question.instruction"></p>
            <p v-show="trans_instruction" v-html="question[selectedLanguage.key + '_instruction']"></p>
          </div>
          
          <div class="slide">
            <transition name="slide-fade" mode="in-out">
              <div class="slide-image square" :style="{backgroundImage: 'url(' + question.image + ')'}"></div>
            </transition>
          </div>

          <!-- Question -->
          <div class="questions-combined">
    
            <div class="box-fill-in-the-blank" :class="isWrapText(question) ? 'wrap' : ''">
              <template  v-for="(fitbdata,fitbidx) in question.fillintheblank">
                <template v-if="fitbdata.type == 'blank'">
                <div :key="`${fitbidx}-1`"  class="fitb-blank-box">
                  <div class="fitb-blank">{{ selectedAnswerText(fitbidx, question) }}</div>
                  <div class="fitb-blank-underline"></div>
                </div>
                </template>
                <template v-else-if="fitbdata.type == 'text'">
                <div :key="`${fitbidx}-2`"  class="fitb-blank-box fitb-box-text">
                  <div class="fitb-text">{{ fitbdata.text }}</div>
                </div>
                </template>
              </template>
            </div>
          </div>

          <!-- Answer Choices -->
          <div class="box-propositions">
            <ul class="grid">
              <li v-for="(proposition,index) in question.propositions" :key="index" class="button button-multiple-choice" @click="selectResponse(proposition,index)" :class="selectedAnswer(proposition.index) ? check(proposition,index) : ''" v-html="proposition.props">
              </li>
            </ul>
          </div>

      </div>

      <!-- Footer -->
      <div class="footer-quiz">
        <div class="box-button flex-between"> 
            <button class="button button-clear" @click="clear()">{{ $t('common.button.clear') }}</button>
            <button class="button button-enter" @click="enter()" :class="!isSelected ? 'disabled' : ''">{{ $t('common.button.enter') }}</button>
        </div>
      </div>
    
    </div>
    <!-- /container-quiz -->

    <div class="container score" v-if="!quiz">
      <div class="heading-content-title">{{ $t('lesson.exam.title') }}</div>
      <div class="box-score">
        <div class="image-score" :class="score_result"></div>
        <div class="score-result" :class="score_result">{{ $t('lesson.question.score.title') }} <p class="score-shown"><span class="score-count">{{score}}</span>/{{questions.length}}</p></div>
        
        <p class="message">
        <template v-if="score_result == 'perfect'">
          {{ $t('lesson.question.score.perfect.message_1') }}<br>
          {{ $t('lesson.question.score.perfect.message_2') }}
        </template>
        <template v-else-if="score_result == 'pass'">
          {{ $t('lesson.question.score.pass.message_1') }}
        </template>
        <template v-else-if="score_result == 'failure'">
          {{ $t('lesson.question.score.failure.message_1') }}
        </template>
        
        </p>
      </div>
    </div>
    
    <div class="modal modal-show" v-show="quiz && answered">
    <transition name="modalfasttransition">
      <div class="modal-content" v-show="quiz && answered">
        <div class="box-button"> 
            <div class="answer-result-box">
            <span>
              <div class="answer-result answer-correct" v-if="isCorrect"><div class="icon-correct"></div>正解！</div>
              <div class="answer-result answer-incorrect" v-else-if="!isCorrect"><div class="icon-incorrect"></div>不正解！</div>
            </span>
            </div>
        </div>
        <div class="box-button button-next-done"> 
            <button class="button next" @click.self="nextQuestion()" :class="(answered) ? 'button-primary' : 'disabled'">{{ $t('common.button.next') }}</button>
        </div>
      </div>
    </transition>
    </div>

</div>
<!-- /row -->
</template>

<script>

import {appEnv} from './../../config';

import questionLog from '../../mixins/question-log';
import {mapGetters} from 'vuex';

import LessonMultiAudio from './LessonMultiAudio.vue'


export default {
  mixins: [questionLog],
  name: "LessonQuestion",
  components: {
    'lessonmultiaudio': LessonMultiAudio,
  },
  props: {
    step: {
      type: String,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    audios: {
      type: Array
    },
  },
  data(){
    return{
      audioType: 'audio',
      lessonId: null,
      contentOrder: null,

      a:0,
      b:1,
      next:true,
      quiz:true,
      score:0,
      progress:0,
      answered:false,
      // next_step:false,
      select_answer:[],
      select_answer_data:[],
      correct_answerd:[],
      incorrect_answerd:[],
      answer_list:[],
      score_result:null,

      lives_cnt:3,
      colorCodes: {
        info: {
          color: "green"
        },
        warning: {
          color: "orange",
          threshold: 15
        },
        alert: {
          color: "red",
          threshold: 10
        }
      },

      trans_instruction:false,
      authUser: null,
      storage: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedLanguage'
    ]),
    isSelected() {
      return (this.select_answer.length >= this.answer_list.length);
    },
    isCorrect () {
      if(this.select_answer.length == this.answer_list.length) {
        if(this.answer_list.length == this.correct_answerd.length) {
          return true
        } else {
          return false
        }
      }
      return false
    }
    
  },

  watch: {

  },
  
  created() {
      
      this.authUser = this.$store.getters.getAuthUser;
      
      this.contentOrder = this.$route.params['content_order']
      this.lessonId = this.$route.params['lesson_id']
      
  },

  mounted() {
    
    this.progress = (100/this.questions.length);
    
    this.correct_list = []
    this.answer_list = this.questions[this.a].answers
    this.select_answer = []
    this.select_answer_data = []
  },
  beforeDestroy() {
  },
  
  methods: {
    
    isWrapText (question) {
      let wordLen = 0;
      question.fillintheblank.forEach(item => {
        if(item.type == 'text') {
          wordLen += item.text.length
        }
      })
      
      let isWordLenOver = false;
      
      if(question.fillintheblank.length == 4) {
        if(wordLen > 2) {
          isWordLenOver = true
        }
      } else if(question.fillintheblank.length == 5) {
        if(wordLen > 0) {
          isWordLenOver = true
        }
      } else if(question.fillintheblank.length < 4) {
        if((wordLen + question.fillintheblank.length) > 6) {
          isWordLenOver = true
        }
      }
      
      
      return (question.fillintheblank.length > 5) || isWordLenOver
    },
    
    changeTrans(key) {
      
      if (key !== 'ja') {
        this.trans_instruction = !this.trans_instruction
      }
    },

    selectResponse(e, index) {
      if (this.answered) {
        return false;
      }
      if (this.select_answer.length >= this.answer_list.length) {
        return false;
      }
      
      let correctIndx = index + 1
      let answerIndex = this.select_answer.length + 1

      if (e.correct && e.index == correctIndx && e.correct_index.includes(answerIndex)) {
        this.correct_answerd.push(correctIndx);
        
      } else {
        this.incorrect_answerd.push(correctIndx);
        
      }
      
      this.select_answer.push(correctIndx)
      this.select_answer_data.push(e)
      
    },

    check(status, index) {
      if(this.answered == false) {
        return 'card-selected'
      } else {
        if (status.correct && this.correctAnswerd(status.index)) {
          return 'correct'
        } else if (this.incorrectAnswerd(status.index)) {
          return 'incorrect'
        }
      }
    },
    
    selectedAnswerText(fibIndex, question) {
      let blankList = []
      
      question.fillintheblank.forEach((item,index) => {
        if(item.type == 'blank') {
          if(fibIndex == index) {
            blankList.push({ selected: true, selectedIdx: index})
          } else {
            blankList.push({ selected: false, selectedIdx: index})
          }
        }
      })
      let propIdx = blankList.findIndex(item => {
        return item.selectedIdx == fibIndex
      })
      
      return (this.select_answer_data.length > propIdx) ? this.select_answer_data[propIdx].props : ""
    },
    
    selectedAnswer(index) {
      return this.select_answer.includes(index)
    },
    
    correctAnswerd(index) {
      return this.correct_answerd.includes(index)
    },
    
    incorrectAnswerd(index) {
      return this.incorrect_answerd.includes(index)
    },
    
    enter() {
      if(this.select_answer.length == this.answer_list.length) {
        if(this.answer_list.length == this.correct_answerd.length) {
          this.score++;
          this.$store.dispatch('playSoundEffect', 'correct')
        } else {
          this.lives_cnt--;
          this.$store.dispatch('playSoundEffect', 'incorrect')
        }
        this.answered = true;
      }
    },
    
    clear() {
      
      this.answered = false
      this.select_answer = []
      this.select_answer_data = []
      this.correct_answerd = []
      this.incorrect_answerd = []
      this.answer_list = this.questions[this.a].answers
    },

    nextQuestion() {
      if (!this.answered) {
        return;
      }
      

      // exam log
      let contentKeys = Object.keys(this.$store.getters.lesson_content.exam.content)
      let question_id = this.$store.getters.lesson_content[this.step].content[contentKeys[0]].questions[this.a].question_id;
      this.questionTempLog('exam', question_id, this.correct_answerd, this.incorrect_answerd);
      
      if (this.lives_cnt <= 0) {
        this.quiz = false;
        this.score_result = 'failure';
        this.$emit('finquiz')
        this.$emit('scoreresult', this.score_result)
      } else if (this.questions.length - 1 == this.a) {
        this.quiz = false;
        // this.next_step = true;
        if (this.score == this.questions.length) {
          this.score_result = 'perfect';
        } else if (this.score <= 2) {
          this.score_result = 'failure';
        } else {
          this.score_result = 'pass';
        }
        this.lessonTempLog(this.score_result);
        
        this.$emit('scoreresult', this.score_result)
        this.$emit('finquiz')
        this.$emit('passedquiz')

        // Update Log
        this.questionLog()

      } else {
        this.progress = this.progress + (100/this.questions.length);
        this.a++;
        this.b++;
        this.clear();
      }
    },

    completedLesson() {
    },
  }
}
</script>

<style scoped lang="scss">
  .base-timer {
    position: relative;
    width: 75px;
    height: 75px;
    margin: 10px auto; // new
    &__circle {
      fill: none;
      stroke: none;
    }
    &__path-elapsed {
      stroke-width: 7px;
      stroke:grey;
      stroke: #e0e0e0;
    }
    &__label {
      position: absolute;      
      width: 75px;
      height: 75px;
      top: 0; 
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }
    &__path-remaining {
      stroke-width: 7px;
      stroke-linecap: round;
      transform: rotate(90deg);
      transform-origin: center;
      transition: 1s linear all;
      stroke: rgb(65, 184, 131); // green
    }
    &__svg {
      transform: scaleX(-1);
    }
    &__path-remaining {
      stroke-width: 7px;
      stroke-linecap: round;
      transform: rotate(90deg);
      transform-origin: center;
      transition: 1s linear all;
      fill-rule: nonzero;
      stroke: currentColor;
      &.green {
        color: rgb(65, 184, 131);
      }
      &.orange {
        color: orange;
      }
      &.red {
        color: red;
      }
    }
  }

  .box-propositions .grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 12px;
  }
  
  .box-propositions .grid .button {
    margin: auto;
  }
  
</style>